import React from 'react';
import { StyledDiv, StyledSubHeader } from '../../Components/Styled';
import { Typography } from '@mui/material';
import DataGridTable from '../../Components/DataGrid';
import { globalSearch } from './constant';
import { globalColumns } from './constant';
const GlobalSearchPage = ({location}) => {

    const inputSearch = location?.state?.searchString;


    return (
        <React.Fragment>
 <          StyledDiv>
                <Typography variant='h6'>GLOBAL SEARCH</Typography>
            </StyledDiv>
            <Typography style={{margin: "30px 0px"}} variant='subtitle1'>Following records found making the term <strong>{inputSearch}</strong></Typography>
            <StyledDiv>
                {
                    Object.keys(globalSearch?.documents).map(item => {
                        return (
                            <>
                            <StyledSubHeader>
                                {item}
                            </StyledSubHeader>
                            <DataGridTable 
                                columns = {globalColumns[item]}
                                dataGridData = {globalSearch?.documents?.[item].map(item => {return {...item, found: `found in ${String(item?.documentType).toLowerCase()}`}})}
                                isRequiredToolBar={false}
                                isCheckboxReq = {false}
                            />
                            </>
                        )
                    })
                }
               
            </StyledDiv>
        </React.Fragment>
    )
}

export default GlobalSearchPage;